import React from "react";
import Button from "../../components/Button";
import { ROUTE_PATHS } from "../../utils/PathsNames";
import { useHistory } from "react-router-dom";

function NotFoundPage() {
  const history = useHistory();
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center", // ✅ Vertically center
        flexDirection: "column",
        height: "80vh", // ✅ Full viewport height
        fontSize: "1rem"
      }}
    >
      <div style={{ textAlign: "center" }}>
        <h1 style={{ fontSize: "10rem" }}>404</h1>
        <h3 style={{ fontSize: "4rem" }}>Page not found</h3>
        <p>{"We can't find the page you were looking for."}</p>
        <Button
          text={"Go to home page"}
          style={{ width: "100%" }}
          onClick={() => history.push(`${ROUTE_PATHS.root}`)}
        />
      </div>
    </div>
  );
}

export default NotFoundPage;
